import { useQuery } from "@apollo/client";
import { GET_SERVICES } from "../graphql/queries";
import { Service } from "../types";

function Services() {
  const { data, loading, error } = useQuery<{ services: Service[] }>(GET_SERVICES);

  if (loading) return <p className="body-text">Loading services...</p>;
  if (error) return <p className="body-text">Error: {error.message}</p>;

  return (
    <div>
      <h1 className="display-text" style={{ fontSize: 42, marginBottom: 8 }}>
        Services
      </h1>
      <p className="body-text" style={{ marginBottom: 32 }}>
        From intimate gatherings to grand celebrations, we handle every detail.
      </p>

      <div className="services-grid">
        {(data?.services ?? []).map((service) => (
          <div key={service.id} className="service-card">
            {service.imageUrl && (
              <img
                src={service.imageUrl}
                alt={service.name}
                style={{
                  width: "100%",
                  height: 180,
                  objectFit: "cover",
                  borderRadius: 16,
                  marginBottom: 16,
                }}
              />
            )}
            <h2 className="h1-text">{service.name}</h2>
            {service.priceRange && (
              <p className="h2-text" style={{ margin: "8px 0" }}>{service.priceRange}</p>
            )}
            <p className="body-text">{service.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Services;
